'use client';

import { createContext, useContext, useState, ReactNode, FC } from 'react';

interface ModalContextType {
  // Credit Purchase Modal
  isCreditPurchaseModalOpen: boolean;
  openCreditPurchaseModal: () => void;
  closeCreditPurchaseModal: () => void;

  // Future modals can be added here
  // isWorkspaceSettingsModalOpen: boolean;
  // openWorkspaceSettingsModal: () => void;
  // closeWorkspaceSettingsModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalProvider: FC<ModalProviderProps> = ({ children }) => {
  const [isCreditPurchaseModalOpen, setIsCreditPurchaseModalOpen] = useState(false);

  const openCreditPurchaseModal = () => setIsCreditPurchaseModalOpen(true);
  const closeCreditPurchaseModal = () => setIsCreditPurchaseModalOpen(false);

  return (
    <ModalContext.Provider
      value={{
        isCreditPurchaseModalOpen,
        openCreditPurchaseModal,
        closeCreditPurchaseModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
